import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FormSelectOption } from '@stylehaven/components';
import { Identifiable } from '../../entities/common/identifiable.interface';
import { RecordSecurityGroups } from '../../entities/management/record-security-groups.entity';
import { SecurityGroup } from '../../entities/management/security-group.entity';
import { RecordService } from '../../record/services/record.service';
import { SecurityGroupService } from '../../services/security/security-group.service';

@Injectable()
export class RecordSecurityGroupsSandboxService {
    constructor(private securityGroupService: SecurityGroupService, private recordService: RecordService) {}

    getSecurityGroupsOfRecord(record: Identifiable): Observable<RecordSecurityGroups> {
        return this.recordService.getSecurityGroups(record);
    }

    getEditableSecurityGroups(): Observable<FormSelectOption[]> {
        return this.securityGroupService.getAll().pipe(
            map((securityGroups: SecurityGroup[]) =>
                securityGroups.filter((securityGroup: SecurityGroup) => !securityGroup.IsReadOnly)
            ),
            map(this.mapToSelectOption.bind(this))
        );
    }

    mapToSelectOption(securityGroups: SecurityGroup[]): FormSelectOption[] {
        return securityGroups.map((securityGroup: SecurityGroup) => ({
            label: securityGroup.Name,
            value: securityGroup.Id as string
        }));
    }
}
